import React, { FunctionComponent, useEffect, Suspense, lazy } from 'react';
import analytics from './lib/analytics';
import history from './lib/history';
import { Spinner } from '@incodocs/style-react';
import { Router, Switch, BrowserRouter } from 'react-router-dom';
import { Route } from './lib/router';
import { ApolloProvider } from 'react-apollo-hooks';
import client from './api/client';
import DocsRouter from './modules/documents/Router';

const NotFoundPage = lazy(() =>
  import('./modules/application/components/NotFoundPage')
);

export const App: FunctionComponent = ({}) => {
  useEffect(() => {
    history.listen(() => {
      analytics.page();
    });
  }, []);
  return (
    <ApolloProvider client={client}>
      <Suspense fallback={<Spinner delay={200} />}>
        <Router history={history}>
          <Switch>
            <Route path="/" component={DocsRouter} />
            <Route component={NotFoundPage} />
          </Switch>
        </Router>
      </Suspense>
    </ApolloProvider>
  );
};
